export const categories = [
  {
    slug: 'xiazai-jiaocheng',
    name: '下载教程',
    description: '快猫app各平台下载安装教程，包含Android、iOS完整步骤指南',
    icon: 'ri-download-cloud-2-line',
    articleCount: 12,
  },
  {
    slug: 'gongneng-jieshao',
    name: '功能介绍',
    description: '快猫app全部功能详细解析，帮助您充分利用每一项特性',
    icon: 'ri-apps-2-line',
    articleCount: 18,
  },
  {
    slug: 'shiyong-jiqiao',
    name: '使用技巧',
    description: '提高使用效率的实用技巧和隐藏功能揭秘',
    icon: 'ri-lightbulb-flash-line',
    articleCount: 15,
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '用户最常遇到的问题及解决方案汇总',
    icon: 'ri-question-answer-line',
    articleCount: 22,
  },
  {
    slug: 'gengxin-rizhi',
    name: '更新日志',
    description: '快猫app各版本更新内容及新功能介绍',
    icon: 'ri-refresh-line',
    articleCount: 8,
  },
  {
    slug: 'anquan-yinsi',
    name: '安全与隐私',
    description: '了解快猫app如何保护您的数据安全与个人隐私',
    icon: 'ri-shield-check-line',
    articleCount: 6,
  },
];

export const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速响应',
    description: '采用先进的算法引擎，内容加载速度快至毫秒级，告别等待焦虑，畅享丝滑体验。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '智能推荐',
    description: '基于AI深度学习，精准分析您的兴趣偏好，智能匹配个性化内容，越用越懂你。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '隐私安全',
    description: '端到端加密技术保护您的所有数据，多重安全防护机制，让您用得放心、玩得安心。',
  },
  {
    icon: 'ri-global-line',
    title: '多端同步',
    description: '支持手机、平板、电脑多平台无缝切换，数据实时同步，随时随地畅享内容。',
  },
  {
    icon: 'ri-palette-line',
    title: '精美界面',
    description: '极简主义设计语言，精心打磨每个交互细节，带来赏心悦目的视觉盛宴。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '7×24小时在线客服团队，快速响应您的每一个问题，用心服务每一位用户。',
  },
];

export const faqItems = [
  {
    question: '快猫app支持哪些操作系统？',
    answer: '快猫app目前全面支持Android 8.0及以上版本和iOS 14.0及以上版本。我们针对不同系统进行了深度优化，确保在所有主流设备上都能流畅运行。同时，我们也提供了PC网页版，方便您在电脑上使用。',
  },
  {
    question: '如何下载安装快猫app？',
    answer: '您可以通过以下几种方式下载：1) 访问快猫app官方网站，扫描首页二维码直接下载；2) 在各大应用商店（如华为应用市场、小米应用商店、App Store等）搜索"快猫app"下载；3) 通过微信公众号"快猫官方"获取下载链接。安装后请按照引导完成注册即可使用。',
  },
  {
    question: '快猫app是免费的吗？',
    answer: '快猫app提供免费版和会员版两种选择。免费版已经包含核心功能，可以满足大部分用户日常使用需求。会员版解锁更多高级功能，包括去广告、专属内容、高清画质、云端存储等特权，价格实惠，性价比极高。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '别担心，您可以在登录页面点击"忘记密码"，通过绑定的手机号或邮箱接收验证码来重置密码。如果您绑定的手机号已不可用，请联系我们的客服团队，我们会通过身份验证后协助您找回账号。',
  },
  {
    question: '快猫app如何保护用户隐私？',
    answer: '我们高度重视用户隐私保护。所有数据传输均采用银行级SSL加密，用户个人信息存储经过多重脱敏处理。我们严格遵守相关法律法规，不会向任何第三方出售或泄露您的个人信息。您可以在"设置-隐私中心"中查看和管理所有隐私授权。',
  },
  {
    question: '使用过程中遇到问题如何反馈？',
    answer: '您可以通过以下渠道反馈：1) App内"我的-帮助与反馈"提交工单；2) 发送邮件至support@kuaimaoapp.com；3) 在官方网站的"联系我们"页面提交表单。我们的客服团队会在24小时内回复处理。',
  },
  {
    question: '快猫app会员可以退款吗？',
    answer: '我们提供7天无理由退款保障。如果您购买会员后不满意，可在购买后7天内通过"我的-会员中心-申请退款"发起退款申请。审核通过后，款项将原路返回至您的支付账户，通常3-5个工作日到账。',
  },
  {
    question: '快猫app会定期更新吗？',
    answer: '是的，我们保持敏捷的开发节奏，通常每2-3周发布一个新版本。每次更新都会修复已知问题、优化性能体验，并带来新的功能。建议您开启自动更新，确保始终使用最新版本获得最佳体验。',
  },
];

export const articles = [
  {
    slug: 'android-xiazai-an-zhuang-jiao-cheng',
    title: '快猫app Android版下载安装完整教程',
    excerpt: '本教程详细讲解如何在Android手机上安全下载并安装快猫app，包含从官网下载、权限设置到首次启动的全流程指南。',
    content: `快猫app作为一款备受欢迎的移动应用，在Android平台上的下载和安装过程非常简单。本文将为您提供最详细的操作指南。

## 一、下载前准备

在开始下载之前，请确保您的Android手机满足以下条件：
- 系统版本在Android 8.0及以上
- 手机存储空间至少200MB
- 网络连接稳定

## 二、官方下载渠道

为了您的安全，建议通过以下官方渠道下载：

1. **官方网站下载**：访问快猫app官网，点击首页的"Android版下载"按钮
2. **应用商店下载**：在华为应用市场、小米应用商店等搜索"快猫app"
3. **扫描二维码下载**：使用手机浏览器扫描官网提供的下载二维码

## 三、安装步骤

1. 下载完成后，点击APK安装文件
2. 如果系统提示"未知来源应用"，请前往"设置-安全"中开启"允许安装未知来源应用"
3. 点击"安装"按钮，等待安装完成
4. 安装完成后点击"打开"启动快猫app

## 四、首次启动设置

1. 打开快猫app，同意用户协议和隐私政策
2. 选择注册方式（手机号或邮箱）
3. 设置个人偏好
4. 完成新手引导

至此，您就可以开始使用快猫app了！`,
    category: 'xiazai-jiaocheng',
    date: '2026-07-28',
    readTime: '8分钟',
    imageSeq: 'article-01',
  },
  {
    slug: 'ios-xiazai-an-zhuang-jiao-cheng',
    title: '快猫app iOS版下载安装详细指南',
    excerpt: '苹果用户专属教程，手把手教您在iPhone和iPad上下载安装快猫app，解决各种安装问题。',
    content: `对于iOS用户来说，下载快猫app的过程与Android略有不同。本文将为您提供完整的iOS版下载安装指南。

## 一、系统要求

- iOS 14.0及以上版本
- iPhone、iPad或iPod touch
- 至少150MB可用空间
- 有效的Apple ID

## 二、下载方式

**方式一：App Store直接下载**

1. 打开App Store应用
2. 点击搜索栏，输入"快猫app"
3. 在搜索结果中找到官方应用（请认准开发者名称）
4. 点击"获取"按钮
5. 通过Face ID、Touch ID或密码验证
6. 等待下载完成

**方式二：官网跳转下载**

1. 使用Safari浏览器访问快猫app官网
2. 点击"iOS版下载"按钮
3. 系统将自动跳转至App Store
4. 按照方式一的步骤完成下载

## 三、常见问题

**下载速度慢**：尝试切换Wi-Fi或使用5G网络
**无法下载**：检查Apple ID区域设置和网络连接
**安装失败**：重启设备后重试

## 四、首次使用

下载完成后，打开快猫app，按照引导完成注册即可开始使用。`,
    category: 'xiazai-jiaocheng',
    date: '2026-07-25',
    readTime: '6分钟',
    imageSeq: 'article-02',
  },
  {
    slug: 'zhineng-tuijian-gongneng-xiangjie',
    title: '快猫app智能推荐功能全面解析',
    excerpt: '深入了解快猫app的AI智能推荐系统是如何运作的，以及如何优化您的推荐内容，让每一次浏览都精准命中喜好。',
    content: `快猫app的智能推荐系统是产品的核心亮点之一，它利用先进的人工智能技术，为每位用户打造个性化的内容体验。

## 一、推荐系统的核心原理

快猫app的推荐引擎基于深度学习模型，通过分析以下维度来理解您的偏好：

1. **浏览历史**：您经常浏览的内容类型和主题
2. **互动行为**：点赞、收藏、评论等互动数据
3. **停留时长**：您在各类内容上的停留时间
4. **搜索记录**：您的主动搜索关键词
5. **时段偏好**：不同时间段的内容偏好差异

## 二、如何优化您的推荐

要让推荐更精准，您可以：

- 积极互动：多点赞、收藏喜欢的内容
- 善用搜索：通过搜索告诉系统您的兴趣
- 使用标签：关注感兴趣的内容标签
- 反馈机制：对不感兴趣的内容使用"不感兴趣"功能

## 三、推荐算法的持续进化

我们的算法团队每周都在优化推荐模型，确保：
- 推荐多样性：避免信息茧房
- 内容新鲜度：优先展示高质量新内容
- 惊喜发现：适时推荐您可能感兴趣的新领域`,
    category: 'gongneng-jieshao',
    date: '2026-07-22',
    readTime: '10分钟',
    imageSeq: 'article-03',
  },
  {
    slug: 'gaoji-sousuo-jiqiao',
    title: '快猫app高级搜索技巧：快速找到你想要的内容',
    excerpt: '掌握这些不为人知的搜索技巧，让你在快猫app中秒搜到目标内容，效率提升10倍。',
    content: `快猫app内置了强大的搜索引擎，但很多用户并不知道它还有很多高级玩法。本文将揭秘这些隐藏的搜索技巧。

## 一、基础搜索

在搜索框中直接输入关键词即可开始搜索。支持中文、英文和拼音搜索。

## 二、高级搜索语法

1. **精确匹配**：使用双引号包围关键词，如"快猫教程"
2. **排除关键词**：使用减号，如"快猫 -广告"
3. **多关键词组合**：使用空格分隔
4. **时间筛选**：在搜索结果页使用时间过滤器

## 三、语音搜索

点击搜索框旁的麦克风图标，可以直接用语音输入搜索内容，支持普通话和粤语。

## 四、图片搜索

快猫app支持以图搜图功能，上传图片即可找到相关内容，非常方便。

## 五、搜索历史管理

在搜索页面可以查看和管理搜索历史，支持单独删除和批量清空。`,
    category: 'shiyong-jiqiao',
    date: '2026-07-20',
    readTime: '7分钟',
    imageSeq: 'article-04',
  },
  {
    slug: 'zhanghu-yichang-jiejue',
    title: '快猫app账号异常问题排查与解决全攻略',
    excerpt: '遇到账号登录异常、被锁定、数据丢失等问题？这篇攻略帮你一步步排查并解决所有账号相关的问题。',
    content: `账号安全是每位用户最关心的问题。当遇到账号异常时，请按照以下步骤进行排查和解决。

## 一、常见异常类型

1. **无法登录**：提示密码错误或账号不存在
2. **账号被锁定**：多次输入错误密码后触发安全锁定
3. **数据丢失**：登录后发现收藏、历史等数据不见了
4. **异地登录提醒**：收到非本人操作的登录通知

## 二、解决方案

**无法登录**
- 检查网络连接
- 确认账号格式正确（手机号/邮箱）
- 使用"忘记密码"重置
- 检查是否被他人修改了绑定信息

**账号被锁定**
- 等待30分钟后自动解锁
- 联系客服加速解锁
- 通过绑定手机/邮箱验证身份

**数据丢失**
- 检查是否登录了不同账号
- 切换网络后重新登录
- 清除App缓存后重试

## 三、预防措施

- 定期修改密码
- 绑定手机号和邮箱
- 开启二次验证
- 不要在公共设备上保存密码`,
    category: 'changjian-wenti',
    date: '2026-07-18',
    readTime: '9分钟',
    imageSeq: 'article-05',
  },
  {
    slug: 'v3-5-0-gengxin-rizhi',
    title: '快猫app V3.5.0 版本更新日志',
    excerpt: '快猫app最新版本V3.5.0正式发布，带来了全新的界面设计、性能优化和多项新功能，快来了解更新内容。',
    content: `我们很高兴地宣布快猫app V3.5.0正式发布！本次更新带来了大量令人兴奋的新功能和优化。

## 新功能

1. **全新视觉设计**：重新设计的用户界面，更加简洁现代
2. **深色模式2.0**：全新的深色主题，更护眼更省电
3. **智能分类**：自动归类您的内容，整理更高效
4. **云端同步增强**：跨设备同步速度提升300%

## 性能优化

- 应用启动速度提升40%
- 图片加载速度提升50%
- 内存占用降低25%
- 电池消耗优化

## 修复问题

- 修复了部分机型上的闪退问题
- 修复了搜索结果显示异常的问题
- 修复了通知延迟的问题
- 修复了若干UI显示问题

## 更新方式

打开快猫app，进入"我的-设置-检查更新"即可获取最新版本。`,
    category: 'gengxin-rizhi',
    date: '2026-07-15',
    readTime: '5分钟',
    imageSeq: 'article-06',
  },
  {
    slug: 'yinsi-zhengce-xiangjie',
    title: '快猫app隐私政策详解：您的数据如何被保护',
    excerpt: '全面解读快猫app隐私政策，用通俗易懂的语言告诉您我们收集了哪些数据、如何使用以及如何保护。',
    content: `隐私保护是快猫app最重视的事项之一。本文用最直白的语言为您解释我们的隐私政策。

## 一、我们收集什么数据

- 账号信息：手机号/邮箱（用于注册登录）
- 设备信息：设备型号、系统版本（用于优化体验）
- 使用数据：浏览记录、搜索记录（用于个性化推荐）
- 位置信息：大致地理位置（仅在您授权后）

## 二、数据如何被使用

所有收集的数据仅用于：
- 提供和改进服务
- 个性化内容推荐
- 安全防护和风险控制
- 产品分析和优化

## 三、数据保护措施

- 银行级加密传输
- 数据脱敏存储
- 严格的访问控制
- 定期的安全审计

## 四、您的权利

您拥有对个人数据的完全控制权，包括查看、修改、导出和删除。`,
    category: 'anquan-yinsi',
    date: '2026-07-12',
    readTime: '8分钟',
    imageSeq: 'article-07',
  },
  {
    slug: 'duoduan-tongbu-shezhi',
    title: '快猫app多端同步功能设置与使用教程',
    excerpt: '教你如何在手机、平板、电脑之间实现数据无缝同步，随时随地接续浏览，不再错过任何精彩内容。',
    content: `快猫app的多端同步功能让您在不同设备之间无缝切换。以下是详细的设置和使用教程。

## 一、支持的设备

- Android手机和平板
- iPhone和iPad
- PC网页版（推荐Chrome浏览器）
- 智能电视（部分型号）

## 二、开启同步功能

1. 在第一个设备登录快猫app
2. 进入"我的-设置-多端同步"
3. 开启"云端同步"开关
4. 在其他设备登录相同账号
5. 同步自动完成

## 三、同步内容

- 浏览历史和书签
- 收藏和点赞记录
- 个人设置和偏好
- 阅读进度
- 下载内容列表

## 四、注意事项

- 确保所有设备网络连接正常
- 同步需要消耗少量流量
- 首次同步可能需要1-2分钟`,
    category: 'shiyong-jiqiao',
    date: '2026-07-10',
    readTime: '6分钟',
    imageSeq: 'article-08',
  },
  {
    slug: 'huiyuan-tequan-jieshao',
    title: '快猫app会员特权功能介绍与购买指南',
    excerpt: '全面了解快猫app会员的各种专属特权，帮你判断是否值得开通会员，以及如何以最优惠的价格购买。',
    content: `快猫app会员为用户提供了一系列专属特权。本文将详细介绍所有会员功能和购买建议。

## 一、会员特权一览

1. **去广告体验**：纯净无广告的使用环境
2. **高清画质**：享受最高清晰度的内容
3. **专属内容**：会员独享的精品内容库
4. **云端存储**：10GB专属云空间
5. **优先体验**：新功能优先试用权
6. **专属客服**：VIP客服快速通道
7. **专属标识**：尊贵的会员身份标识

## 二、会员套餐

- 月度会员：¥15/月
- 季度会员：¥40/季（省¥5）
- 年度会员：¥128/年（省¥52，日均仅需¥0.35）

## 三、购买方式

在快猫app内进入"我的-会员中心"，选择套餐后使用微信支付或支付宝即可完成购买。

## 四、退款政策

支持7天无理由退款，不满意可随时申请。`,
    category: 'gongneng-jieshao',
    date: '2026-07-08',
    readTime: '7分钟',
    imageSeq: 'article-09',
  },
  {
    slug: 'wangluo-lianjie-wenti-paicha',
    title: '快猫app网络连接问题排查终极指南',
    excerpt: '加载缓慢、连接超时、无法刷新？这篇终极排查指南覆盖所有网络问题的解决方案。',
    content: `网络连接问题是用户最常遇到的困扰。本文汇总了所有常见网络问题的排查方法。

## 一、快速诊断

1. 打开其他App确认网络是否正常
2. 切换Wi-Fi和移动数据对比测试
3. 访问快猫app官网确认服务器状态

## 二、常见解决方案

**Wi-Fi环境**
- 重启路由器
- 忘记网络后重新连接
- 切换2.4GHz/5GHz频段
- 检查路由器是否限制了某些端口

**移动数据环境**
- 检查App的移动数据权限
- 确认流量没有超标
- 切换飞行模式后重试
- 重置APN设置

**通用方法**
- 清除快猫app缓存
- 重启手机
- 更新到最新版本
- 重新安装App

## 三、依然无法解决？

如果以上方法都无效，请联系客服并提供您的网络环境和错误截图。`,
    category: 'changjian-wenti',
    date: '2026-07-05',
    readTime: '8分钟',
    imageSeq: 'article-10',
  },
  {
    slug: 'yejian-moshi-shezhi',
    title: '快猫app夜间模式设置与护眼技巧分享',
    excerpt: '学会设置快猫app的夜间模式，搭配科学的护眼技巧，让你的眼睛在长时间使用后依然舒适。',
    content: `长时间使用手机对眼睛的伤害不容忽视。快猫app提供了完善的护眼功能。

## 一、开启夜间模式

1. 进入"我的-设置-显示设置"
2. 点击"夜间模式"
3. 选择"始终开启"、"定时切换"或"跟随系统"

## 二、定时切换设置

建议设置为日落后自动开启、日出后自动关闭，与自然光线同步。

## 三、自定义主题

快猫app夜间模式支持：
- 深色程度调节（深灰/纯黑）
- 字体亮度独立调节
- 图片亮度自动适配

## 四、护眼小技巧

- 遵循20-20-20法则：每20分钟看20英尺外20秒
- 保持屏幕亮度与环境光线协调
- 使用防蓝光屏幕保护膜
- 定期做眼部放松运动`,
    category: 'shiyong-jiqiao',
    date: '2026-07-02',
    readTime: '5分钟',
    imageSeq: 'article-11',
  },
  {
    slug: 'xin-shou-ru-men-zhi-nan',
    title: '快猫app新手入门完全指南：从零开始快速上手',
    excerpt: '刚下载快猫app不知道从哪里开始？这篇新手完全指南带你30分钟内熟悉所有核心功能，快速融入快猫社区。',
    content: `欢迎来到快猫app！如果你是第一次使用，这篇指南将帮助你快速上手。

## 一、注册与登录

1. 打开快猫app，点击"注册"
2. 输入手机号获取验证码
3. 设置密码和昵称
4. 选择感兴趣的领域
5. 完成注册，开始探索

## 二、界面导览

- **首页**：个性化内容推荐流
- **发现**：热门内容和分类浏览
- **搜索**：精准查找想要的内容
- **消息**：互动通知和私信
- **我的**：个人中心和设置

## 三、核心操作

1. **浏览内容**：上下滑动浏览推荐内容
2. **互动操作**：双击点赞、长按更多选项
3. **收藏**：点击收藏按钮保存内容
4. **分享**：一键分享给好友

## 四、个性化设置

花几分钟设置好个人偏好，体验会好很多！`,
    category: 'xiazai-jiaocheng',
    date: '2026-06-28',
    readTime: '10分钟',
    imageSeq: 'article-12',
  },
];